const LocalStorage = {
  getSidebarPinState() {
    let value;
    try {
      value = JSON.parse(
        window.localStorage.getItem("sidebarPinState" /* SIDEBAR_PIN_STATE */) || "true"
      );
    } catch {
      return true;
    }
    return !!value;
  },
  setSidebarPinState(state) {
    return window.localStorage.setItem(
      "sidebarPinState" /* SIDEBAR_PIN_STATE */,
      JSON.stringify(state)
    );
  }
};

export { LocalStorage };
//# sourceMappingURL=localStorage.esm.js.map
